import { useMediaQuery } from '@mantine/hooks';
import { MODAL_SIZES, BREAKPOINT_PX } from '../theme/mantineTheme';

const FULLSCREEN_BREAKPOINT = `(max-width: ${BREAKPOINT_PX.xs}px)`;

/**
 * Returns the appropriate modal size, switching to fullscreen on narrow
 * viewports (at or below the Mantine `xs` breakpoint — see BREAKPOINT_PX.xs).
 *
 * @param desktopSize – One of the MODAL_SIZES tokens (defaults to `detail`).
 */
export function useModalFullscreen(
    desktopSize: string | number = MODAL_SIZES.detail,
): { size: string | number; fullScreen: boolean } {
    const isNarrow = useMediaQuery(FULLSCREEN_BREAKPOINT, false);

    return isNarrow
        ? { size: MODAL_SIZES.fullscreen, fullScreen: true }
        : { size: desktopSize, fullScreen: false };
}
